import type { HeliosCellDataExtended } from 'types/helios/agendaListing';
import type { DataRecordColumn } from 'types/dataHelios';
import { isEmpty } from './filterFormUtils';
import { isObjectEmpty } from '../typeChecks';

type BrowseUpdatedEntries = Array<{ id: string; status: 'add' | 'remove' }>;

export const countHeliosBrowseItems = (cellData: HeliosCellDataExtended | DataRecordColumn, fieldValue: BrowseUpdatedEntries | unknown): number => {
  const originalEntries =
    cellData?.columnType === 'RelationDynamic' ? (cellData?.dynamicRelationValuesCount ?? 0) : cellData?.relationStaticValue ? 1 : 0;
  const addedRemovedEntries = Array.isArray(fieldValue) ? (fieldValue as BrowseUpdatedEntries) : [];
  const { addedEntries, removedEntries } = addedRemovedEntries.reduce(
    (statusAggregatedEntries, currentEntry) => {
      if (typeof currentEntry === 'object' && currentEntry !== null && 'status' in currentEntry) {
        if (currentEntry.status === 'add') {
          statusAggregatedEntries.addedEntries.push(currentEntry);
        } else if (currentEntry.status === 'remove') {
          statusAggregatedEntries.removedEntries.push(currentEntry);
        }
      }
      return statusAggregatedEntries;
    },
    {
      addedEntries: [] as BrowseUpdatedEntries,
      removedEntries: [] as BrowseUpdatedEntries,
    }
  );
  return originalEntries + addedEntries.length - removedEntries.length;
};

export const isHeliosValueEmpty = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }

  if (isEmpty(value)) {
    return true;
  }

  if (typeof value === 'object') {
    return isObjectEmpty(value);
  }

  return false;
};
